import { useEffect, useState } from 'react';
import { GridColDef, GridRowModel } from '@mui/x-data-grid';
import ReusableDataGrid from '../ReusableDataGrid.tsx';
import { getContactPoints, createContactPoint, updateContactPoint, deleteContactPoint } from '../../services/api.ts';

const FREQUENCY_OPTIONS = [
  { value: 0,  label: 'Once'           },
  { value: 1,  label: 'Every hour'     },
  { value: 4,  label: 'Every 4 hours'  },
  { value: 24, label: 'Every 24 hours' },
];

const defaultRow: Record<string, number | string | boolean | null> = {
  email:              '',
  notify_every_hours: 24,
  isNew:              true,
};

const columns: GridColDef[] = [
  {
    field:     'email',
    headerName: 'Email',
    type:       'string',
    flex:       1,
    editable:   true,
  },
  {
    field:        'notify_every_hours',
    headerName:   'Notification Frequency',
    type:         'singleSelect',
    flex:         1,
    editable:     true,
    valueOptions: FREQUENCY_OPTIONS,
  },
];

export default function AlertContactsDataGrid() {
  const [initialRows, setInitialRows] = useState([]);

  useEffect(() => {
    getContactPoints().then(setInitialRows);
  }, []);

  const handleSaveRow = async (row: GridRowModel) => {
    const { isNew, id, ...fields } = row;
    if (isNew) {
      const [created] = await createContactPoint(fields as any);
      return { ...created, isNew: false };
    } else {
      const [updated] = await updateContactPoint(id, fields as any);
      return { ...updated, isNew: false };
    }
  };

  const handleDeleteRow = async (row: GridRowModel) => {
    await deleteContactPoint(row.id);
  };

  return (
    <ReusableDataGrid
      defaultRow={defaultRow}
      columns={columns}
      height='75vh'
      width='100%'
      initialRows={initialRows}
      onSaveRow={handleSaveRow}
      onDeleteRow={handleDeleteRow}
    />
  );
}
